import React, { useState ,useEffect} from "react";
import "./Style.css";
import Navbar from "./nav/navbar/Navbar";
import Carousel from "./Carousel/Carousel";
import Footer from "./Footer/Footer";
import Navmenu from "./nav/navmenu/Navmenu";
import Sidebar from "./sidebar/Sidebar";
import SimpleBottomNavigation from "./BottomNav/SimpleBottomNavigation.jsx"
import {  useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import Productlayout from "./product/productlayout";
import Backend from "./backend/Backend"
import Essential from "./Essential/Essential";


const Home = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const isOpen = useSelector(state => state.sidebar );

 
  return(
    <>
      <Navbar />
      {isMobile?isOpen?<Sidebar/>:"":<Navmenu/>}
      <Carousel/>
      <Productlayout/>
      <Essential/>
      <Footer />
      {isMobile ?<SimpleBottomNavigation/>:""}
    </>
  );
};
export default Home;
